import styled from 'styled-components';
import GameIconCanvas from '../svgs/GameIconCanvas.svg';
import GameBlockSelected from '../svgs/GameBlockSelected.svg';
import GameBlockShadow from '../svgs/GameBlockShadow.svg';

export const IconImageWrapper = styled.div`
  width: 116px;
  height: 119px;
  top: 23px;
  left: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${({ canvas }) => canvas && GameIconCanvas});
`;

export const Title = styled.div`
  font-size: 21px;
  text-align: center;
  font-family: 'Quicksand';
  color: #ffffff;
  padding: 5px;
`;

export const TitleContainer = styled.div`
  height: 63px;
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
 `;

export const Container = styled.button`
  position: absolute;
  width: 180px;
  height: 216px;
  border: none;
  background: transparent;
  background-image: url(${GameBlockShadow}), url(${({ selected }) => selected && GameBlockSelected});
  cursor: ${({ completed }) => (completed ? 'default' : 'pointer')};

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${IconImageWrapper} {
    opacity: ${({ completed }) => (completed ? 0.3 : 1)};
  };
  ${Title} {
    opacity: ${({ completed }) => (completed ? 0.3 : 1)};
  };
`;
